import { useEffect, useState } from 'react'

/** Avance visuellement les étapes pendant une opération longue (API). */
export default function useSimulatedStepIndex(active, stepDurationMs = 2400, maxStep = 2) {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (!active) {
      setIndex(0)
      return undefined
    }

    setIndex(0)
    const timers = []
    for (let i = 1; i <= maxStep; i += 1) {
      timers.push(setTimeout(() => setIndex(i), stepDurationMs * i))
    }
    return () => timers.forEach(clearTimeout)
  }, [active, stepDurationMs, maxStep])

  return index
}
